const STEPS = [
  {
    n: "01",
    title: "Cargas el pedido de tu cliente",
    body: "En un solo lugar: quién lo pide, qué necesita, los archivos y tus notas. Nada suelto en el chat.",
  },
  {
    n: "02",
    title: "Lo mueves por tu propio flujo",
    body: "Armas las columnas como trabajas —diseño, aprobación, impresión, entrega— y cada trabajo avanza a la vista.",
  },
  {
    n: "03",
    title: "Tu cliente sigue el avance",
    body: "Se entera por correo cada vez que su trabajo cambia de estado, sin tener que llamarte para preguntar.",
  },
];

/**
 * "Cómo funciona" for the broker audience. Framed from the studio's own
 * workflow — organizing their jobs and keeping clients informed — without
 * claiming to solve print providers or validate files (that's the printer's
 * world, not the broker's).
 */
export function BrokerFlow() {
  return (
    <section id="flujos" className="border-t border-[var(--separator)] py-20 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="max-w-2xl">
          <p className="text-sm font-semibold uppercase tracking-wider text-[var(--muted)]">
            Cómo funciona
          </p>
          <h2 className="mt-3 text-balance text-3xl font-bold tracking-tight text-[var(--foreground)] sm:text-4xl">
            Tu trabajo, ordenado de principio a fin.
          </h2>
          <p className="mt-4 text-lg text-[var(--muted)]">
            Del diseño y de mandarlo a imprimir te encargas tú. De que nada se pierda en el medio,
            Ciam.
          </p>
        </div>

        <ol className="mt-12 grid gap-6 sm:grid-cols-3">
          {STEPS.map((step) => (
            <li key={step.n} className="relative">
              <span className="text-5xl font-extrabold leading-none text-[color-mix(in_oklch,var(--accent)_28%,transparent)]">
                {step.n}
              </span>
              <h3 className="mt-4 text-lg font-semibold text-[var(--foreground)]">{step.title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-[var(--muted)]">{step.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
